import { render, staticRenderFns } from "./otherincomes.vue?vue&type=template&id=66225123&"
import script from "./otherincomes.vue?vue&type=script&lang=js&"
export * from "./otherincomes.vue?vue&type=script&lang=js&"
import style0 from "./otherincomes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports